import { useQuery } from '@tanstack/react-query'
import { PublicMultipassProductWithBookingInfoEntity } from '../../../qourses-api-client'
import { qoursesApi } from '../../api/qourses.tsx'

export default function useGetMultipassProductsPublic(organizationId: string): {
  multipassProducts: PublicMultipassProductWithBookingInfoEntity[]
  isLoading: boolean
  isEmpty: boolean
  isError: boolean
} {
  const {
    data: multipassProducts,
    isLoading,
    isError,
  } = useQuery(['public', 'multipassProducts'], async () => {
    return qoursesApi.multipassPublic.multipassPublicControllerGetMultipassProductsV1(
      organizationId,
    )
  })

  let isEmpty = true

  if (multipassProducts === undefined) {
    return { multipassProducts: [], isLoading, isEmpty, isError }
  }

  if (multipassProducts.length > 0) {
    isEmpty = false
  }

  return { multipassProducts, isLoading, isEmpty, isError }
}
